<ng-container *ngIf="data">
    <div class="mb-5" *ngFor="let g of groups">
        <h5>{{'planSummary_totals_type' + g.name | translate}}</h5>

        <div class="totals-row">
            <div *ngFor="let n of g.totals" class="totals-item">
                <div class="totals-header">
                    <div class="totals-type">{{n.TypeName}}</div>
                    <div class="totals-details">
                        <ng-container *ngIf="n.RequiredUnits > 0; else noData">
                            <span class="totals-percent">{{n.ObtainedPercent}}%</span>
                        </ng-container>

                        <ng-template #noData>
                            <span class="totals-empty">{{'planSummary_totals_noData' | translate}}</span>
                        </ng-template>
                    </div>
                </div>

                <div class="total-bar">
                    <div [style]="'width:' + n.ObtainedPercent + '%'"
                         [class.bg-danger]="n.ObtainedPercent < 50"
                         [class.bg-warning]="n.ObtainedPercent >= 50 && n.ObtainedPercent < 100"
                         [class.bg-success]="n.ObtainedPercent == 100"></div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
